import React, { useEffect } from 'react';
import LegalLayout from './LegalLayout';

const summaryLinks = [
  {
    "href": "#escopo",
    "label": "Escopo"
  },
  {
    "href": "#contratacao",
    "label": "Contratação"
  },
  {
    "href": "#planos",
    "label": "Planos"
  },
  {
    "href": "#precos",
    "label": "Preços"
  },
  {
    "href": "#cupons",
    "label": "Cupons"
  },
  {
    "href": "#pagamento",
    "label": "Pagamento"
  },
  {
    "href": "#inadimplencia",
    "label": "Inadimplência"
  },
  {
    "href": "#cancelamento",
    "label": "Cancelamento"
  },
  {
    "href": "#reembolso",
    "label": "Reembolso"
  },
  {
    "href": "#suporte",
    "label": "Suporte"
  },
  {
    "href": "#contato",
    "label": "Contato"
  }
];

const sections = [
  {
    "id": "escopo",
    "title": "1. Escopo e importância deste documento",
    "paragraphs": [
      "Estas Condições Comerciais complementam os Termos de Uso e a Política de Privacidade da plataforma Lumix Óticas, explicando de forma objetiva as regras de contratação, planos, preços, cupons, cobranças, renovação, inadimplência, cancelamento, reembolso, alterações comerciais e uso de recursos contratados.",
      "Este documento é especialmente recomendado para constar no checkout, no rodapé do site, na página de planos e no aceite da contratação, pois reduz dúvidas comerciais e registra de forma transparente o que o cliente está contratando antes de efetuar o pagamento.",
      "A Lumix Óticas é uma plataforma SaaS B2B voltada à gestão de óticas. A contratação é direcionada a pessoas jurídicas, empresários, gestores, administradores ou profissionais que utilizam a plataforma em contexto empresarial. Quando houver relação de consumo reconhecida por lei em caso específico, serão observadas as normas aplicáveis ao consumidor."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "identificacao",
    "title": "2. Identificação da Lumix e canais oficiais",
    "paragraphs": [
      "Para fins destas Condições Comerciais, “Lumix”, “Lumix Óticas”, “Plataforma”, “nós” ou “serviço” significa [INSERIR RAZÃO SOCIAL], pessoa jurídica inscrita no CNPJ sob nº [INSERIR CNPJ], com sede em [INSERIR ENDEREÇO COMPLETO].",
      "Canal comercial oficial: [INSERIR E-MAIL COMERCIAL] e [INSERIR WHATSAPP OFICIAL]. Canal de suporte: [INSERIR E-MAIL DE SUPORTE]. Canal de privacidade e LGPD: [INSERIR E-MAIL DE PRIVACIDADE/DPO].",
      "A Lumix poderá considerar como comunicação válida aquela enviada pelos canais cadastrados pelo administrador da conta, incluindo e-mail, WhatsApp, painel administrativo, checkout, notificações internas ou outros meios oficiais informados pela plataforma."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "documentos",
    "title": "3. Relação com Termos de Uso e Política de Privacidade",
    "paragraphs": [
      "A contratação e o uso da plataforma são regidos por três documentos principais: Termos de Uso, Política de Privacidade e estas Condições Comerciais.",
      "Os Termos de Uso tratam das regras gerais de acesso, uso, responsabilidades, limitações, segurança, obrigações da contratante e funcionamento da plataforma. A Política de Privacidade trata do tratamento de dados pessoais, LGPD, papéis de controlador e operador, segurança, incidentes, direitos dos titulares e suboperadores. Estas Condições Comerciais tratam das regras econômicas e operacionais da contratação.",
      "Em caso de conflito entre documentos, prevalecerá a regra mais específica para o assunto tratado, sem prejuízo da aplicação da legislação vigente e da interpretação sistemática dos documentos."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "contratacao",
    "title": "4. Processo de contratação",
    "paragraphs": [
      "A contratação poderá ocorrer por checkout online, link de pagamento, atendimento comercial consultivo, proposta personalizada, negociação direta ou outro meio oficial disponibilizado pela Lumix.",
      "Antes da ativação definitiva, a Lumix poderá solicitar validação de e-mail, confirmação de pagamento, conferência de plano, verificação de dados cadastrais, confirmação de identidade do responsável, análise antifraude ou validação manual quando necessário.",
      "Ao contratar, pagar, criar conta, aceitar o checkout ou utilizar a plataforma, a contratante declara que leu e concorda com os Termos de Uso, a Política de Privacidade e estas Condições Comerciais, bem como declara possuir poderes para vincular a empresa ou operação representada."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "planos",
    "title": "5. Planos, limites e recursos contratados",
    "paragraphs": [
      "Os planos da Lumix são organizados de acordo com a quantidade de empresas, lojas, unidades, usuários, recursos, módulos, integrações, volume operacional ou outras métricas comerciais informadas no checkout ou proposta.",
      "A disponibilidade de recursos pode variar conforme o plano contratado, a fase de implantação, integrações ativas, permissões da conta, configurações técnicas, módulos contratados e evolução natural do produto.",
      "A Lumix poderá oferecer planos públicos, planos personalizados, planos de implantação, planos para clientes fundadores, planos promocionais e planos empresariais. Os valores e limites válidos são aqueles exibidos no checkout, proposta comercial, contrato, painel de assinatura ou comunicação oficial da Lumix no momento da contratação.",
      "A criação de empresas, unidades, usuários, integrações, campanhas, anexos, envios, automações ou demais recursos poderá ser limitada conforme o plano contratado. A tentativa de burlar limites de plano poderá resultar em ajuste de cobrança, bloqueio preventivo, suspensão de recursos ou cancelamento, conforme os Termos de Uso."
    ],
    "bullets": [],
    "table": {
      "headers": [
        "Categoria de plano",
        "Uso previsto",
        "Observação comercial"
      ],
      "rows": [
        [
          "Start",
          "Operação inicial ou uma unidade",
          "Recursos essenciais para OS, CRM, atendimento, pós-venda e gestão básica, conforme tabela vigente."
        ],
        [
          "Crescimento",
          "Operação com mais de uma loja/unidade",
          "Gestão com visão por unidade, expansão comercial e recursos adicionais conforme plano."
        ],
        [
          "Multiempresas/Empresarial",
          "Redes, grupos ou operações maiores",
          "Limites, recursos, suporte, integrações e valores podem ser definidos por proposta."
        ],
        [
          "Fundador/Implantação",
          "Primeiros clientes ou fase assistida",
          "Condições especiais podem depender de permanência ativa e pagamento em dia."
        ]
      ]
    },
    "notice": null
  },
  {
    "id": "precos",
    "title": "6. Preços, tributos e reajustes",
    "paragraphs": [
      "Os preços da plataforma são informados em reais, salvo indicação expressa em contrário, e podem variar conforme plano, quantidade de empresas, usuários, módulos, serviços adicionais, promoções, descontos, integrações, implantação, suporte ou proposta personalizada.",
      "Salvo indicação expressa, os valores anunciados correspondem à mensalidade da assinatura e não incluem custos externos, tarifas de terceiros, taxas de gateway, serviços de mensageria, emissão fiscal, certificados digitais, domínios, hospedagens próprias, equipamentos, configuração fora do escopo contratado, deslocamentos ou serviços personalizados.",
      "A Lumix poderá reajustar valores por atualização de tabela, correção monetária, ampliação de escopo, aumento de custos operacionais, inclusão de recursos, alteração de fornecedores, mudança tributária ou negociação comercial. Alterações relevantes serão informadas por canal oficial com antecedência razoável, quando aplicável.",
      "Planos promocionais, fundadores ou personalizados poderão ter regras próprias de reajuste, manutenção de preço, perda do benefício, migração e atualização, desde que informadas na contratação ou em comunicação oficial."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "cupons",
    "title": "7. Cupons, descontos e promoções",
    "paragraphs": [
      "Cupons e descontos promocionais são benefícios comerciais temporários, facultativos e condicionados às regras informadas no momento da oferta.",
      "Salvo indicação expressa e escrita em sentido contrário, cupons de desconto são aplicados exclusivamente à primeira mensalidade ou ao primeiro ciclo de cobrança, não se incorporando ao preço normal do plano nos meses seguintes.",
      "A partir da segunda mensalidade ou do ciclo subsequente, a assinatura será cobrada pelo valor normal do plano vigente no momento da contratação, conforme checkout, proposta ou tabela aplicável.",
      "Cupons podem ter prazo de validade, limite de uso, limitação por CNPJ, e-mail, empresa, plano, campanha, quantidade de lojas, canal de venda, período promocional ou condição específica.",
      "A Lumix poderá cancelar, recusar, reverter ou revisar cupons usados de forma fraudulenta, duplicada, indevida, automatizada, incompatível com a oferta, fora do prazo ou contrária à finalidade da promoção."
    ],
    "bullets": [],
    "table": null,
    "notice": "Exemplo: em um plano de R$ 200,00 com cupom de 50% apenas na primeira mensalidade, o primeiro pagamento será de R$ 100,00 e, a partir do segundo mês, a cobrança volta ao valor normal do plano, salvo regra expressa diferente."
  },
  {
    "id": "fundadores",
    "title": "8. Clientes fundadores e implantação assistida",
    "paragraphs": [
      "A Lumix poderá oferecer condições especiais para clientes fundadores, beta testers, clientes de implantação assistida ou primeiros aderentes da plataforma.",
      "Benefícios de fundador podem incluir preço especial, prioridade de suporte, participação em sugestões de funcionalidades, condições de implantação ou acesso antecipado a recursos em evolução.",
      "Salvo regra expressa diferente, condições de fundador são pessoais, não transferíveis, vinculadas à conta contratante original e dependem da manutenção do plano ativo, pagamento em dia e ausência de cancelamento, pausa, chargeback, fraude ou violação dos Termos de Uso.",
      "A fase de implantação assistida pode envolver ajustes, evolução de funcionalidades, mudanças de layout, alterações de fluxo, substituição de recursos e correções técnicas. Isso não caracteriza falha contratual quando ocorrer dentro do ciclo normal de evolução de produto SaaS."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "pagamento",
    "title": "9. Pagamento, gateway e confirmação",
    "paragraphs": [
      "A assinatura é, em regra, mensal e pré-paga. O acesso completo aos recursos contratados depende da confirmação do pagamento pelo gateway, instituição financeira, intermediador de pagamento ou validação manual da Lumix.",
      "A Lumix poderá utilizar Mercado Pago ou outros processadores de pagamento para viabilizar cartão, Pix, boleto, assinatura recorrente, link de pagamento, cobrança manual ou outros meios disponíveis.",
      "A aprovação, recusa, contestação, estorno, chargeback, antifraude, compensação bancária e liquidação do pagamento podem depender de terceiros. A Lumix não controla integralmente os prazos e decisões de instituições financeiras, adquirentes, bandeiras, bancos ou gateways.",
      "O cliente é responsável por manter dados de pagamento atualizados, limite disponível, cartão válido, saldo suficiente, e-mail correto, telefone atualizado e informações cadastrais compatíveis com a cobrança."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "renovacao",
    "title": "10. Renovação da assinatura",
    "paragraphs": [
      "A assinatura será renovada automaticamente a cada ciclo, quando houver recorrência ativa, meio de pagamento válido e ausência de cancelamento solicitado nos termos deste documento.",
      "A data de renovação, vencimento ou cobrança poderá corresponder ao dia da primeira ativação, à data definida no checkout, à data da proposta, à data de migração ou a outra data informada no painel ou comunicação oficial.",
      "Em meses com menos dias, vencimentos poderão ser ajustados automaticamente para o último dia disponível do mês ou para o próximo dia útil, conforme regra do gateway, banco ou sistema de cobrança.",
      "O uso contínuo da plataforma após a renovação, cobrança ou disponibilização do ciclo contratado poderá caracterizar continuidade da assinatura e aceite das condições comerciais vigentes."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "ativacao",
    "title": "11. Ativação, liberação e implantação",
    "paragraphs": [
      "A liberação inicial da conta poderá ocorrer automaticamente após pagamento aprovado ou manualmente após conferência comercial, técnica, antifraude ou de dados cadastrais.",
      "Alguns recursos podem depender de configuração adicional, como integração com WhatsApp, emissão fiscal, certificado digital, cadastro de empresas, configuração de unidades, permissões, importação de dados, templates, imagens, automações, estoque ou parâmetros fiscais.",
      "Prazos de implantação, quando informados, são estimativas operacionais e podem depender da colaboração da contratante, envio correto de dados, credenciais, certificados, informações fiscais, disponibilidade de terceiros, validações externas e complexidade do ambiente."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "inadimplencia",
    "title": "12. Atraso, inadimplência e suspensão",
    "paragraphs": [
      "O atraso no pagamento poderá gerar notificações de cobrança, tentativa de nova cobrança, restrição de recursos, suspensão parcial ou total do acesso, interrupção de automações, bloqueio de novas emissões, bloqueio de integrações, limitação de suporte ou cancelamento da assinatura.",
      "A Lumix poderá conceder prazo de tolerância comercial, mas essa tolerância não constitui direito adquirido, renúncia de cobrança, alteração contratual ou obrigação de repetição em ciclos futuros.",
      "Durante a suspensão por inadimplência, os dados poderão permanecer armazenados pelo período de retenção aplicável, mas a contratante poderá ficar impedida de criar novos registros, enviar automações, emitir documentos, acessar módulos ou utilizar recursos pagos.",
      "A reativação ocorrerá após compensação, confirmação do pagamento, regularização das pendências e eventual validação interna. O prazo de reativação pode variar conforme o gateway, banco, forma de pagamento e processamento técnico."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "upgrades",
    "title": "13. Upgrade, downgrade e alteração de plano",
    "paragraphs": [
      "A contratante poderá solicitar upgrade, downgrade, inclusão ou remoção de empresas, unidades, módulos ou recursos, conforme disponibilidade comercial e técnica da Lumix.",
      "Upgrades poderão gerar cobrança proporcional, diferença de plano, nova data de renovação, nova condição comercial ou substituição da assinatura anterior.",
      "Downgrades poderão limitar recursos, empresas, usuários, histórico, anexos, automações, integrações ou funcionalidades disponíveis. Antes de solicitar downgrade, a contratante deve avaliar impactos operacionais e exportar dados quando necessário.",
      "A Lumix poderá recusar downgrade quando houver pendência financeira, uso acima do limite do plano inferior, risco técnico, incompatibilidade de dados, obrigação legal ou necessidade de regularização prévia."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "cancelamento",
    "title": "14. Cancelamento",
    "paragraphs": [
      "O cancelamento poderá ser solicitado pelo administrador da conta ou responsável autorizado, por canal oficial indicado pela Lumix ou por funcionalidade disponível no painel, quando houver.",
      "Salvo regra expressa em proposta ou contrato específico, não há fidelidade compulsória na assinatura mensal. Após o cancelamento, o acesso poderá permanecer ativo até o fim do período já pago ou ser encerrado conforme a modalidade contratada e o status da conta.",
      "O cancelamento impede novas cobranças futuras, mas não extingue automaticamente débitos já vencidos, cobranças em processamento, valores devidos por uso anterior, taxas de terceiros, serviços adicionais já prestados ou obrigações legais.",
      "Após o cancelamento, a contratante deve exportar ou solicitar seus dados dentro do prazo disponibilizado pela Lumix, observadas as regras de retenção, backup, segurança, obrigações legais e Política de Privacidade."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "reembolso",
    "title": "15. Reembolso, arrependimento e estornos",
    "paragraphs": [
      "Como regra geral, assinaturas SaaS mensais são cobradas de forma pré-paga e o pagamento remunera a disponibilidade da plataforma durante o ciclo contratado, ainda que a contratante utilize parcialmente os recursos.",
      "Pedidos de reembolso serão avaliados conforme a legislação aplicável, a natureza B2B da contratação, o canal de venda, eventual relação de consumo reconhecida, falha comprovada, duplicidade de cobrança, cobrança indevida, erro operacional, proposta específica ou política promocional aplicável.",
      "Quando aplicável o direito de arrependimento em contratação online, a Lumix observará os prazos e condições previstos na legislação brasileira. Em contratações empresariais, personalizadas, com implantação, uso efetivo, recursos liberados, serviços já prestados ou integrações configuradas, a análise poderá considerar a natureza do serviço e os custos já incorridos.",
      "Chargebacks, contestações ou estornos indevidos poderão resultar em bloqueio preventivo da conta, suspensão de acesso, cobrança administrativa, cancelamento de benefícios promocionais e adoção de medidas para exercício regular de direitos."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "servicos-adicionais",
    "title": "16. Serviços adicionais, integrações e terceiros",
    "paragraphs": [
      "Determinadas funcionalidades podem depender de serviços de terceiros, como gateway de pagamento, WhatsApp, mensageria, hospedagem, APIs fiscais, certificados digitais, provedores de e-mail, banco de dados, serviços de nuvem, autenticação, ferramentas de segurança e suporte.",
      "Custos, regras, limitações, instabilidades, mudanças de API, bloqueios, revisão de políticas, indisponibilidades ou exigências desses terceiros podem impactar funcionalidades da plataforma sem que isso represente, por si só, descumprimento da Lumix.",
      "Serviços personalizados, migração de dados, importação complexa, treinamento adicional, configuração fiscal avançada, implantação presencial, desenvolvimento sob demanda, integrações exclusivas ou suporte fora do escopo do plano poderão ser cobrados separadamente mediante proposta."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "uso-abusivo",
    "title": "17. Uso abusivo, limites técnicos e consumo excessivo",
    "paragraphs": [
      "A Lumix poderá aplicar limites técnicos razoáveis para preservar estabilidade, segurança, custos de infraestrutura e qualidade do serviço, incluindo limites de armazenamento, anexos, requisições, mensagens, importações, usuários, empresas, automações, logs e integrações.",
      "Uso anormal, abusivo, automatizado, fraudulento, excessivo ou incompatível com o plano contratado poderá gerar alerta, limitação, cobrança adicional, migração obrigatória para plano superior, suspensão preventiva ou cancelamento, conforme gravidade e risco.",
      "A contratante não deve utilizar a plataforma para spam, disparos abusivos, scraping, mineração, engenharia reversa, ataques, violação de dados, acesso não autorizado, compartilhamento indevido de credenciais, burla de plano ou atividade ilícita."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "notas-fiscais",
    "title": "18. Notas fiscais, documentos fiscais e obrigações tributárias",
    "paragraphs": [
      "Quando aplicável, a Lumix poderá emitir nota fiscal, recibo, fatura, comprovante ou documento equivalente referente aos valores pagos pela assinatura ou serviços adicionais.",
      "A contratante é responsável por fornecer dados fiscais corretos, razão social, CNPJ, endereço, inscrição municipal/estadual quando aplicável e demais informações necessárias à emissão adequada.",
      "Funcionalidades de emissão fiscal usadas pela ótica dentro da plataforma dependem de dados, credenciais, certificados, configurações e responsabilidade da própria contratante, conforme Termos de Uso e legislação fiscal aplicável."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "suporte",
    "title": "19. Suporte, atendimento e prioridades",
    "paragraphs": [
      "O suporte será prestado pelos canais oficiais da Lumix, dentro dos horários, escopo, prioridades e disponibilidade informados comercialmente.",
      "Atendimentos relacionados a erro sistêmico, indisponibilidade relevante, segurança, cobrança, acesso e falhas críticas poderão receber prioridade conforme avaliação técnica. Dúvidas operacionais, melhorias, personalizações, treinamentos e solicitações comerciais poderão seguir fila própria.",
      "Clientes fundadores, empresariais ou com plano personalizado poderão ter condições diferenciadas de suporte quando previsto em proposta, contrato ou comunicação comercial."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "alteracoes",
    "title": "20. Alterações das Condições Comerciais",
    "paragraphs": [
      "A Lumix poderá atualizar estas Condições Comerciais para refletir mudanças de planos, preços, funcionalidades, fornecedores, legislação, regras de cobrança, segurança, operação, estratégia comercial ou evolução da plataforma.",
      "Mudanças relevantes poderão ser comunicadas por e-mail, WhatsApp, painel, checkout, site, notificação interna ou outro canal oficial. O uso continuado da plataforma após a atualização poderá caracterizar ciência e concordância com as novas condições, respeitados direitos adquiridos quando aplicáveis.",
      "Condições personalizadas firmadas por escrito poderão prevalecer sobre a tabela pública, desde que não contrariem a legislação, os Termos de Uso, a Política de Privacidade e os limites técnicos da plataforma."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  },
  {
    "id": "contato",
    "title": "21. Contato e disposições finais",
    "paragraphs": [
      "Dúvidas sobre planos, pagamentos, cupons, renovação, bloqueio, cancelamento, reembolso ou proposta comercial devem ser enviadas aos canais oficiais da Lumix: [INSERIR E-MAIL COMERCIAL] e [INSERIR WHATSAPP OFICIAL].",
      "Estas Condições Comerciais devem ser interpretadas em conjunto com os Termos de Uso e a Política de Privacidade. A eventual tolerância da Lumix quanto a descumprimentos pontuais não significa renúncia de direitos, alteração contratual ou autorização para repetição da conduta.",
      "Foro: fica eleito o foro da comarca de [INSERIR CIDADE/UF], salvo quando a legislação aplicável determinar foro diverso de forma obrigatória."
    ],
    "bullets": [],
    "table": null,
    "notice": null
  }
];

function RenderParagraph({ children }) {
  return <p>{children}</p>;
}

function RenderBullets({ items }) {
  if (!items || !items.length) return null;
  return (
    <ul className="lumix-commercial-list">
      {items.map((item, index) => (
        <li key={index}>
          {Array.isArray(item) ? (
            <>
              <strong>{item[0]}:</strong> {item[1]}
            </>
          ) : (
            item
          )}
        </li>
      ))}
    </ul>
  );
}

function RenderTable({ table }) {
  if (!table) return null;
  return (
    <div className="lumix-table-wrap">
      <table className="lumix-legal-table">
        <thead>
          <tr>
            {table.headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function CondicoesComerciaisLumix() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePrint = () => {
    if (typeof window !== 'undefined') window.print();
  };

  return (
    <LegalLayout
      eyebrow="Contratação e Assinatura"
      title="Condições Comerciais"
      description="Regras de contratação, planos, preços, cupons, cobrança, renovação, inadimplência, cancelamento e reembolso da plataforma Lumix Óticas."
      summaryLinks={summaryLinks}
    >
      <style>{`
        .lumix-commercial-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          margin: -2px 0 34px;
          padding: 18px 20px;
          border: 1px solid #e3e8ef;
          border-radius: 16px;
          background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
          box-shadow: 0 1px 2px rgba(15, 23, 42, .03);
        }

        .lumix-commercial-header > div {
          min-width: 0;
        }

        .lumix-commercial-header p {
          max-width: 640px;
          margin: 7px 0 0;
          color: #6b7280;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 12px;
          line-height: 1.6;
          font-weight: 500;
        }

        .lumix-commercial-badge {
          display: inline-flex;
          align-items: center;
          min-height: 25px;
          padding: 0 9px;
          border-radius: 999px;
          background: #eef5ff;
          color: #1a73e8;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 9px;
          line-height: 1;
          font-weight: 800;
          letter-spacing: .075em;
          text-transform: uppercase;
        }

        .lumix-print-button {
          appearance: none;
          min-height: 40px;
          padding: 0 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
          border: 1px solid #d5dde8;
          border-radius: 11px;
          background: #fff;
          color: #343943;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          font-weight: 750;
          cursor: pointer;
          white-space: nowrap;
          box-shadow: 0 1px 2px rgba(15, 23, 42, .04);
          transition: background .16s ease, border-color .16s ease, transform .16s ease;
        }

        .lumix-print-button:hover {
          background: #f8fafc;
          border-color: #c8d2df;
          transform: translateY(-1px);
        }

        .legal-article > section {
          scroll-margin-top: 96px;
        }

        .legal-article > section > h2 {
          position: relative;
          margin-top: 42px;
          padding-bottom: 13px;
          border-bottom: 1px solid #e6ebf1;
          font-family: 'Nunito', 'Inter', system-ui, sans-serif;
          font-size: 1.22rem;
          line-height: 1.35;
          font-weight: 900;
          letter-spacing: -.025em;
        }

        .legal-article > section > h2::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -1px;
          width: 42px;
          height: 2px;
          border-radius: 999px;
          background: #1a73e8;
        }

        .legal-article > section:first-of-type > h2 {
          margin-top: 0;
        }

        .lumix-commercial-list {
          display: grid;
          gap: 7px;
          margin: 8px 0 20px;
          padding-left: 1.25rem;
        }

        .lumix-commercial-list li {
          padding-left: 3px;
          color: #46505f;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 12px;
          line-height: 1.75;
          font-weight: 450;
        }

        .lumix-commercial-list li::marker {
          color: #1a73e8;
        }

        .lumix-commercial-list strong {
          color: #20242c;
          font-weight: 800;
        }

        .lumix-table-wrap {
          overflow-x: auto;
          margin: 20px 0 10px;
          border: 1px solid #e3e8ef;
          border-radius: 15px;
          background: #fff;
          box-shadow: 0 1px 2px rgba(15, 23, 42, .025);
        }

        .lumix-legal-table {
          width: 100%;
          min-width: 700px;
          border-collapse: collapse;
        }

        .lumix-legal-table th {
          padding: 12px 14px;
          text-align: left;
          border-bottom: 1px solid #e3e8ef;
          background: #f8fafc;
          color: #626a78;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 9px;
          line-height: 1.3;
          font-weight: 800;
          letter-spacing: .07em;
          text-transform: uppercase;
        }

        .lumix-legal-table td {
          padding: 14px;
          border-bottom: 1px solid #edf0f4;
          color: #46505f;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          line-height: 1.65;
          vertical-align: top;
          font-weight: 450;
        }

        .lumix-legal-table td:first-child {
          color: #20242c;
          font-weight: 750;
        }

        .lumix-legal-table tr:last-child td {
          border-bottom: 0;
        }

        .lumix-commercial-note {
          position: relative;
          margin: 18px 0 8px;
          padding: 14px 15px 14px 17px;
          border: 1px solid #d7e5fa;
          border-radius: 13px;
          background: #f6f9fe;
          color: #3d5f8d;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          line-height: 1.65;
          font-weight: 500;
        }

        .lumix-commercial-note::before {
          content: '';
          position: absolute;
          left: 0;
          top: 12px;
          bottom: 12px;
          width: 3px;
          border-radius: 0 999px 999px 0;
          background: #1a73e8;
        }

        .lumix-commercial-note strong {
          color: #1a73e8;
          font-weight: 800;
        }

        @media (max-width: 720px) {
          .lumix-commercial-header {
            align-items: stretch;
            flex-direction: column;
            margin-bottom: 26px;
            padding: 15px;
            border-radius: 14px;
          }

          .lumix-commercial-header p {
            font-size: 11px;
          }

          .lumix-print-button {
            width: 100%;
          }

          .legal-article > section > h2 {
            margin-top: 34px;
            font-size: 1.06rem;
          }

          .lumix-table-wrap {
            margin-left: -4px;
            margin-right: -4px;
            border-radius: 12px;
          }

          .lumix-commercial-note {
            font-size: 10px;
          }
        }

        @media print {
          .lumix-print-button {
            display: none !important;
          }

          .lumix-commercial-header {
            box-shadow: none;
          }

          .lumix-table-wrap {
            overflow: visible;
          }

          section {
            break-inside: avoid;
            page-break-inside: avoid;
          }

          a {
            color: inherit;
            text-decoration: none;
          }
        }
      `}</style>

      <div className="lumix-commercial-header">
        <div>
          <span className="lumix-commercial-badge">Atualizado em 28 de maio de 2026</span>
          <p>
            Documento complementar aos Termos de Uso e à Política de Privacidade da plataforma Lumix Óticas.
          </p>
        </div>
        <button type="button" className="lumix-print-button" onClick={handlePrint}>
          Imprimir / salvar PDF
        </button>
      </div>

      {sections.map((section) => (
        <section id={section.id} key={section.id}>
          <h2>{section.title}</h2>
          {section.paragraphs.map((paragraph, index) => (
            <RenderParagraph key={index}>{paragraph}</RenderParagraph>
          ))}
          <RenderBullets items={section.bullets} />
          <RenderTable table={section.table} />
          {section.notice ? (
            <div className="lumix-commercial-note">
              <strong>Observação:</strong> {section.notice}
            </div>
          ) : null}
        </section>
      ))}

      <section id="referencias">
        <h2>Referências normativas consideradas</h2>
        <ul className="lumix-commercial-list">
          <li>Lei nº 13.709/2018 - Lei Geral de Proteção de Dados Pessoais (LGPD).</li>
          <li>Lei nº 12.965/2014 - Marco Civil da Internet.</li>
          <li>Lei nº 8.078/1990 - Código de Defesa do Consumidor, quando aplicável.</li>
          <li>Decreto nº 7.962/2013 - Contratação no comércio eletrônico, quando aplicável.</li>
          <li>Orientações da ANPD sobre agentes de tratamento, incidentes de segurança e transferência internacional de dados.</li>
        </ul>
        <div className="lumix-commercial-final-note">
          <strong>Nota jurídica:</strong> esta minuta aumenta a transparência comercial e reduz riscos de disputa, mas a versão final deve ser validada por advogado com os dados reais da empresa, política de preços, foro, canais oficiais e operação comercial definitiva.
        </div>
      </section>
    </LegalLayout>
  );
}
